import { useCallback } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useQueryParamHelper } from '@shared/core/queryString';
import type { EventFeatureFlagKey } from './eventFeatureFlags.types';

export const useEventFeatureFlagsContext = () => {
  const { eventInfo, loading } = useEventInfo();
  const { getValueString } = useQueryParamHelper();

  const isEventFeatureFlagEnabled = useCallback(
    (flag: EventFeatureFlagKey) => {
      // 1. Check URL Query Parameter: feature.${flag}
      const maybeQueryParamValue = getValueString(`feature.${flag}`);
      if (maybeQueryParamValue) {
        return maybeQueryParamValue === 'true';
      }

      // 2. Check GraphQL event flags (already fetched by EventInfo)
      return eventInfo?.featureFlags?.includes(flag) ?? false;
    },
    [eventInfo, getValueString],
  );

  return {
    loading,
    isEventFeatureFlagEnabled,
  };
};
